/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

function localizeDiscountySavings() {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;

  document.querySelectorAll('.discounty-cart-widget__saving-label').forEach((label) => {
    if (label.textContent.trim() === 'Saving') label.textContent = 'Économie';
  });
}

function observeDiscountySavings() {
  localizeDiscountySavings();

  if (window.__caspirolusDiscountyObserver) return;
  window.__caspirolusDiscountyObserver = new MutationObserver(localizeDiscountySavings);
  window.__caspirolusDiscountyObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeDiscountySavings, { once: true });
} else {
  observeDiscountySavings();
}
